import moment from 'moment';

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

export const columns = [
    {    
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'createdOn',
        text: 'Created On',
        sort: true,
        headerStyle: headerStyle,
        formatter: (_cell, row) => {
            return moment(row.createdOn).format('MM/DD/YYYY hh:mm A')
        }
    },
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];